import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { AvisosConfService } from '../../services/avisosConf.service';
import { AvisosConf } from '../../models/avisos.model';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AvisosAddNodeComponent } from '../avisos-add-node/avisos-add-node.component';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
/**
 * Node for to-do item
 */
var TodoItemNode = /** @class */ (function () {
    function TodoItemNode() {
    }
    return TodoItemNode;
}());
export { TodoItemNode };
/** Flat to-do item node with expandable and level information */
var TodoItemFlatNode = /** @class */ (function () {
    function TodoItemFlatNode() {
    }
    return TodoItemFlatNode;
}());
export { TodoItemFlatNode };
var TREE_DATA = {
    Groceries: {
        'Almond Meal flour': null,
        'Organic eggs': null,
        'Protein Powder': null,
        Fruits: {
            Apple: null,
            Berries: ['Blueberry', 'Raspberry'],
            Orange: null
        }
    },
    Reminders: [
        'Cook dinner',
        'Read the Material Design spec',
        'Upgrade Application to Angular'
    ]
};
/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
var ChecklistDatabase = /** @class */ (function () {
    function ChecklistDatabase(avisosconfService) {
        this.avisosconfService = avisosconfService;
        this.dataChange = new BehaviorSubject([]);
        this.initialize();
    }
    Object.defineProperty(ChecklistDatabase.prototype, "data", {
        get: function () { return this.dataChange.value; },
        enumerable: true,
        configurable: true
    });
    ChecklistDatabase.prototype.initialize = function () {
        var _this = this;
        // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
        //     file node as children.
        this.avisosconfService.getAvisos().subscribe(function (result) {
            var avisos = Object.assign(result);
            var data = _this.buildFileTree(avisos, 0);
            // Notify the change.
            _this.dataChange.next(data);
        });
    };
    ChecklistDatabase.prototype.refresh = function () {
        this.dataChange.next(this.data);
    };
    ChecklistDatabase.prototype.refresh2 = function () {
        var _this = this;
        this.avisosconfService.getAvisos().subscribe(function (result) {
            var avisos = Object.assign(result);
            var data = _this.buildFileTree(avisos, 0);
            _this.dataChange.next(data);
        });
    };
    /**
     * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
     * The return value is the list of `TodoItemNode`.
     */
    ChecklistDatabase.prototype.buildFileTree = function (obj, level) {
        var _this = this;
        return Object.keys(obj).reduce(function (accumulator, key) {
            var value = obj[key].children;
            var node = new TodoItemNode();
            node.item = new AvisosConf(obj[key].id, obj[key].nom, obj[key].mail, obj[key].pareId, obj[key].isFolder, obj[key].text, obj[key].alarma);
            if (value != null) {
                if (typeof value === 'object') {
                    node.children = _this.buildFileTree(value, level + 1);
                }
                else {
                    node.item = value;
                }
            }
            return accumulator.concat(node);
        }, []);
    };
    /** Add an item to to-do list */
    ChecklistDatabase.prototype.insertItem = function (parent, child) {
        if (parent.children) {
            parent.children.push(child);
            this.dataChange.next(this.data);
        }
    };
    return ChecklistDatabase;
}());
export { ChecklistDatabase };
/**
 * @title Tree with checkboxes
 */
var AvisosTableComponent = /** @class */ (function () {
    function AvisosTableComponent(_database, dialog, changeDetectorRefs, i18n, thisDialogRef, avisosconfService, toastr, auth) {
        var _this = this;
        this._database = _database;
        this.dialog = dialog;
        this.changeDetectorRefs = changeDetectorRefs;
        this.i18n = i18n;
        this.thisDialogRef = thisDialogRef;
        this.avisosconfService = avisosconfService;
        this.toastr = toastr;
        this.auth = auth;
        /** Map from flat node to nested node. This helps us finding the nested node to be modified */
        this.flatNodeMap = new Map();
        /** Map from nested node to flattened node. This helps us to keep the same object for selection */
        this.nestedNodeMap = new Map();
        /** A selected parent node to be inserted */
        this.selectedParent = null;
        /** The new item's name */
        this.newItemName = '';
        /** The selection for checklist */
        this.checklistSelection = new SelectionModel(true /* multiple */);
        this.getLevel = function (node) { return node.level; };
        this.isExpandable = function (node) { return node.expandable; };
        this.getChildren = function (node) { return node.children; };
        this.hasChild = function (_, _nodeData) { return _nodeData.expandable; };
        this.hasNoContent = function (_, _nodeData) { return _nodeData.item === null; };
        /**
         * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
         */
        this.transformer = function (node, level) {
            var existingNode = _this.nestedNodeMap.get(node);
            var flatNode = existingNode && existingNode.item === node.item ? existingNode : new TodoItemFlatNode();
            flatNode.item = node.item;
            flatNode.level = level;
            flatNode.expandable = !!node.children;
            _this.flatNodeMap.set(flatNode, node);
            _this.nestedNodeMap.set(node, flatNode);
            return flatNode;
        };
        this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
        this.treeControl = new FlatTreeControl(this.getLevel, this.isExpandable);
        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
        _database.dataChange.subscribe(function (data) {
            _this.dataSource.data = data;
        });
    }
    /** Whether all the descendants of the node are selected. */
    AvisosTableComponent.prototype.descendantsAllSelected = function (node) {
        var _this = this;
        var descendants = this.treeControl.getDescendants(node);
        var descAllSelected = descendants.every(function (child) {
            return _this.checklistSelection.isSelected(child);
        });
        return descAllSelected;
    };
    /** Whether part of the descendants are selected */
    AvisosTableComponent.prototype.descendantsPartiallySelected = function (node) {
        var _this = this;
        var descendants = this.treeControl.getDescendants(node);
        var result = descendants.some(function (child) { return _this.checklistSelection.isSelected(child); });
        return result && !this.descendantsAllSelected(node);
    };
    /** Toggle the to-do item selection. Select/deselect all the descendants node */
    AvisosTableComponent.prototype.todoItemSelectionToggle = function (node) {
        var _this = this;
        var _a, _b;
        this.checklistSelection.toggle(node);
        var descendants = this.treeControl.getDescendants(node);
        this.checklistSelection.isSelected(node)
            ? (_a = this.checklistSelection).select.apply(_a, descendants) : (_b = this.checklistSelection).deselect.apply(_b, descendants);
        // Force update for the parent
        descendants.every(function (child) {
            return _this.checklistSelection.isSelected(child);
        });
        this.checkAllParentsSelection(node);
    };
    /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
    AvisosTableComponent.prototype.todoLeafItemSelectionToggle = function (node) {
        this.checklistSelection.toggle(node);
        this.checkAllParentsSelection(node);
    };
    /* Checks all the parents when a leaf node is selected/unselected */
    AvisosTableComponent.prototype.checkAllParentsSelection = function (node) {
        var parent = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    };
    /** Check root node checked state and change it accordingly */
    AvisosTableComponent.prototype.checkRootNodeSelection = function (node) {
        var _this = this;
        var nodeSelected = this.checklistSelection.isSelected(node);
        var descendants = this.treeControl.getDescendants(node);
        var descAllSelected = descendants.every(function (child) {
            return _this.checklistSelection.isSelected(child);
        });
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        }
        else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
    };
    /* Get the parent node of a node */
    AvisosTableComponent.prototype.getParentNode = function (node) {
        var currentLevel = this.getLevel(node);
        if (currentLevel < 1) {
            return null;
        }
        var startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (var i = startIndex; i >= 0; i--) {
            var currentNode = this.treeControl.dataNodes[i];
            if (this.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
        return null;
    };
    /** Select the category so we can insert the new item. */
    AvisosTableComponent.prototype.addNewItem = function (node) {
        var _this = this;
        var parentNode = this.flatNodeMap.get(node);
        this.dialog.open(AvisosAddNodeComponent, {
            closeOnNavigation: false,
            autoFocus: true,
            data: [parentNode, false],
            width: '30%',
        }).afterClosed().subscribe(function () {
            _this.treeControl.expand(node);
            _this._database.refresh();
        });
    };
    AvisosTableComponent.prototype.editItem = function (nodeflat) {
        var _this = this;
        var node = this.flatNodeMap.get(nodeflat);
        this.dialog.open(AvisosAddNodeComponent, {
            closeOnNavigation: false,
            autoFocus: true,
            data: [node, true],
            width: '30%',
        }).afterClosed().subscribe(function () {
            _this.treeControl.expand(nodeflat);
            _this._database.refresh();
        });
    };
    /** Save the node to database */
    AvisosTableComponent.prototype.saveNode = function (node, itemValue) {
        var nestedNode = this.flatNodeMap.get(node);
        // this._database.updateItem(nestedNode!, itemValue);
    };
    AvisosTableComponent.prototype.removeItem = function (node) {
        var _this = this;
        this.avisosconfService.deleteAvis(node.item).subscribe(function (result) {
            var parent = _this.getParentNode(node);
            var parentNode = _this.flatNodeMap.get(parent);
            var index = parentNode.children.findIndex(function (x) { return x.item === node.item; });
            parentNode.children.splice(index, 1);
            _this._database.refresh();
            _this.treeControl.expand(parent);
            _this.toastr.info(_this.i18n('Element eliminat correctament'));
        });
    };
    return AvisosTableComponent;
}());
export { AvisosTableComponent };
/**  Copyright 2019 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
